export default __webpack_public_path__ + "static/media/Poppins-SemiBold.e67a02ce.ttf";